import Link from 'next/link';
import * as React from 'react';

import cn from 'classnames';
import { motion } from 'framer-motion';

import Preloader from './preloader';
import { ButtonSize, PropsButton, VariantButton } from './type';

import styles from './button.module.scss';

const Button: React.FC<PropsButton> = ({
  type,
  children,
  variant = VariantButton.contained,
  href,
  size = ButtonSize.m,
  onClick,
  className,
  disabled = false,
  loading = false,
  leftIcon,
  rightIcon,
}) => {
  if (href) {
    return (
      <Link href={href}>
        <motion.div
          whileTap={{ y: 3 }}
          onClick={onClick}
          className={cn(styles.button, { [styles.buttonSizeS]: size === 's' }, [
            className,
          ])}>
          {children}
        </motion.div>
      </Link>
    );
  }

  const render = (): JSX.Element => {
    if (loading) {
      return <Preloader />;
    }

    return (
      <>
        {leftIcon}
        <span className="full-width">{children}</span>
        {rightIcon}
      </>
    );
  };

  return (
    <motion.button
      whileTap={{ y: 3 }}
      type={type}
      className={cn(styles.button, [className], {
        [styles.buttonSizeS]: size === 's',
        [styles.outlined]: variant === 'outlined',
      })}
      disabled={disabled || loading}
      onClick={onClick}>
      {render()}
    </motion.button>
  );
};

export default Button;
